import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

/**
 * Textarea component matching design system specifications
 */
export const Textarea = forwardRef(({ className, label, requiredIndicator, id, ...props }, ref) => {
  const textareaId = id || `textarea-${props.name || Math.random().toString(36).substr(2, 9)}`;
  
  return (
    <div className="w-full">
      {label && (
        <label 
          htmlFor={textareaId}
          className="block text-meta font-medium text-gray-700 dark:text-gray-300 mb-1"
        >
          {label}
          {requiredIndicator && props.required && (
            <span className="text-[var(--ds-status-danger)] ml-1">*</span>
          )}
        </label>
      )}
      <textarea
        id={textareaId}
        className={cn(
          'flex min-h-[80px] w-full',
          'bg-[var(--ds-control-field-bg)]',
          'border border-[var(--ds-control-field-border)]',
          'rounded-[var(--ds-radius-md)]',
          'px-3 py-2',
          'text-meta text-[var(--ds-text-primary)]',
          'placeholder:text-[var(--ds-text-muted)]',
          'focus:outline-none focus:ring-2 focus:ring-[var(--ds-accent-focus-ring)]',
          'focus:border-[var(--ds-accent-primary)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'resize-none',
          'transition-colors duration-180',
          className
        )}
        ref={ref}
        {...props}
      />
    </div>
  );
});

Textarea.displayName = 'Textarea';

